import React from 'react';
import SimpsonsQuotes from '../../container/SimpsonsQuotes';
import './app.css';

export default function App() {
  return (
    <main>
      <section>
        <SimpsonsQuotes />
      </section>
    </main>
  );
}
